import type { BootstrapResult } from '../auth/bootstrap'
import { login } from '../auth/keycloak'
import { useBranding } from '../brand/BrandingProvider'
import { Icon } from '../components/icons'
import { Stack, Standalone } from '../components/layout'

/*
  The sign-in screens (ADR 0020): the brief hold while Keycloak redirects, and "the sign-in
  service did not answer" when check-sso timed out. Stacked logo on cream, the credit line in
  the footer. Always the platform brand (brief §2.8).
*/
export function SignIn({
  result,
}: {
  result: Extract<BootstrapResult, { mode: 'login' | 'unreachable' }>
}) {
  const branding = useBranding()

  if (result.mode === 'login') {
    return (
      <Standalone testId="sign-in">
        <Stack>
          <h2>Signing you in…</h2>
          <p className="hint m-0">Taking you to the sign-in page.</p>
          <button type="button" className="btn btn-primary" onClick={login}>
            Sign in
          </button>
        </Stack>
      </Standalone>
    )
  }

  return (
    <Standalone testId="sign-in">
      <Stack>
        <h2>
          <Icon name="offline" /> The sign-in service did not answer
        </h2>
        <p className="m-0">
          {branding.productName} could not reach its sign-in service. Check the connection and try
          again.
        </p>
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
          Try again
        </button>
        {branding.supportEmail && <p className="hint m-0">Support: {branding.supportEmail}</p>}
      </Stack>
    </Standalone>
  )
}
